export default "__VITE_ASSET__BLxXfTFb__"